/// <amd-module name="typeahead/core/EmptyQueryDataProvider" />
/// <amd-dependency path="jquery" name="$"/>

import {EmptyQueryRequestGenerator} from "typeahead/core/EmptyQueryRequestGenerator";
import {IDataProvider, IDataProviderResponse} from "typeahead/core/IDataProvider";
import {ProblemOrigin} from "typeahead/core/logging/ProblemOrigin";
import {Severity} from "typeahead/core/logging/Severity";
import TypeaheadErrorLogger from "typeahead/core/logging/TypeaheadErrorLogger";

export class EmptyQueryDataProvider implements IDataProvider {
    public fetchData(options: any): JQueryPromise<IDataProviderResponse> {
        let opts: any = options.options;
        let context: IContext = <IContext> options.context;
        let urlOpts: ISuggestServiceUrlOptions = <ISuggestServiceUrlOptions> {serviceUrl: context.serviceUrl};
        return new EmptyQueryRequestGenerator(EmptyQueryRequestGenerator.ESS_ABACUS_IDS, urlOpts)
            .makeRequest("", opts, context).then(this.onSuccess, this.onError);
    }

    private onSuccess(json: any): IDataProviderResponse {
        return json.sr ? {results: json.sr} : (json.r ? {results: json.r} : {results: []});
    }

    private onError(): IDataProviderResponse {
        return {results: []};
    }
}
